import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

interface GatewayLossDialogProps {
  open: boolean;
  planName: string;
  pendingCount: number;
  /** Keep the current plan (close without buying). */
  onKeep: () => void;
  /** Continue to checkout anyway. */
  onContinue: () => void;
}

/** #1024 - shown before buying a plan without the Gateway while the account has one. */
export const GatewayLossDialog: React.FC<GatewayLossDialogProps> = ({ open, planName, pendingCount, onKeep, onContinue }) => {
  const { t } = useTranslation(namespace);
  const k = (key: string, opts?: Record<string, unknown>) => t(`planSelectionV2.gatewayLoss.${key}`, opts);
  return (
    <Dialog open={open} onClose={onKeep} maxWidth="xs" fullWidth data-testid="gateway-loss-dialog">
      <DialogTitle>{k('title', { plan: planName })}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1 }}>{k('body')}</Typography>
        {pendingCount > 0 && (
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{k('pending', { count: pendingCount })}</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onContinue} color="inherit" data-testid="gateway-loss-continue">{k('continue', { plan: planName })}</Button>
        <Button onClick={onKeep} variant="contained" autoFocus data-testid="gateway-loss-keep">{k('keep')}</Button>
      </DialogActions>
    </Dialog>
  );
};
